// extracted by mini-css-extract-plugin
module.exports = {"grid":"course-unit-experimental_grid__QYuha"};